<template>
  <v-container idgrid-list-md text-xs-center fluid>
    <v-row row wrap>
      <v-text-field
        append-icon="search"
        v-model="searchText"
        :placeholder="resx.labels.filterVisitors"
      >
      </v-text-field>
    </v-row>
    <v-row row wrap>
      <v-list
        style="width: 100%"
        two-line
        v-if="filteredVisitors && filteredVisitors.length > 0"
      >
        <template v-for="visitor in filteredVisitors">
          <v-list-group
            :sub-group="$vuetify.breakpoint.smAndUp"
            :no-action="$vuetify.breakpoint.smAndUp"
            :key="visitor._id"
            :value="true"
            v-if="
              $store.state.auth.user.roles[0] !=
                $store.state.constants.roles.SECURITY
            "
          >
            <v-list-item slot="activator">
              <v-list-item-action>
                <v-badge overlap color="error">
                  <span
                    slot="badge"
                    v-if="countInvalidObligations(visitor) > 0"
                    >{{ countInvalidObligations(visitor) }}</span
                  >
                  <v-icon color="primary">commute</v-icon>
                </v-badge>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  <text-highlight :queries="searchText">{{
                    visitor.description
                  }}</text-highlight>
                </v-list-item-title>
                <v-list-item-subtitle>
                  {{ `${resx.labels.domain}: `
                  }}<text-highlight :queries="searchText">{{
                    visitor.uniqueIdentifier
                  }}</text-highlight>
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-divider></v-divider>
          </v-list-group>
          <v-list-item :key="visitor._id" v-else>
            <v-col class="col-7 ">
              <v-row>
                <v-list-item-action v-if="visitor.visitor_type == 'vehicle'">
                  <v-icon :color="'gray'">commute</v-icon>
                </v-list-item-action>
                <v-list-item-action v-if="visitor.visitor_type == 'employee'">
                  <v-icon :color="'gray'">people</v-icon>
                </v-list-item-action>
                <v-list-item-content v-if="visitor.visitor_type == 'vehicle'">
                  <v-list-item-title>
                    <text-highlight :queries="searchText">{{
                      visitor.vehicle.description
                    }}</text-highlight>
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    {{ `${resx.labels.domain}: `
                    }}<text-highlight :queries="searchText">{{
                      visitor.vehicle.uniqueIdentifier
                    }}</text-highlight>
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-content v-if="visitor.visitor_type == 'employee'">
                  <v-list-item-title>
                    <text-highlight :queries="searchText">{{
                      visitor.employee.firstName
                    }}</text-highlight
                    >&nbsp;<text-highlight :queries="searchText">{{
                      visitor.employee.lastName
                    }}</text-highlight>
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    {{ `${visitor.employee.identifier.type.toUpperCase()} `
                    }}<text-highlight :queries="searchText">{{
                      visitor.employee.identifier.number
                    }}</text-highlight>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-row>
            </v-col>
            <v-col class="5">
              <v-list-item-action v-if="visit.state == 'active'">
                <v-select
                  :items="getVisitorStates(visitor.state)"
                  item-text="name"
                  item-value="value"
                  name="visitorState"
                  v-model="visitor.state"
                  @change="updateVisitorState(visitor)"
                />
              </v-list-item-action>
            </v-col>
          </v-list-item>
        </template>
      </v-list>
      <v-alert color="primary" icon="info" v-else :value="true">
        {{ resx.messages.noDataAvailable }}
      </v-alert>
    </v-row>
  </v-container>
</template>

<script>
"use strict";

import TextHighlight from "vue-text-highlight";

import contractorCompanyService from "@/services/ContractorCompanyService";

export default {
  name: "visitDetailsVisitors",
  async mounted() {
    this.visitors = await contractorCompanyService.getVisitors(this.visit._id);
  },
  components: {
    TextHighlight
  },
  computed: {
    filteredVisitors() {
      const regexp = new RegExp(this.searchText, "i");
      return this.visitors.filter(v => {
        return (
          (v.visitor_type == "vehicle" &&
            (regexp.test(v.vehicle.description) ||
              regexp.test(v.vehicle.uniqueIdentifier))) ||
          (v.visitor_type == "employee" &&
            (regexp.test(v.employee.firstName) ||
              regexp.test(v.employee.lastName) ||
              regexp.test(v.employee.identifier.number)))
        );
      });
    }
  },
  data() {
    const resx = this.$store.state.locale.resx;
    return {
      searchText: "",
      checkedVisitors: [],
      visitorStates: [
        { name: resx.labels.visitorEntered, value: "entered" },
        { name: resx.labels.visitorLeft, value: "left" },
        { name: resx.labels.visitorReEntered, value: "reentered" }
      ],
      visitors: []
    };
  },
  methods: {
    isAuthorized() {
      let isAuthorized = true;
      for (let index in this.checkedVisitors) {
        if (this.checkedVisitors[index] != null) {
          isAuthorized =
            isAuthorized && !this.isDelayed(this.checkedVisitors[index]._id);
        }
      }
      return isAuthorized;
    },
    countInvalidObligations(visitor) {
      this.getVisitorObligations(visitor).filter(
        o => o.status == this.$store.state.constants.OBLIGATIONS.STATUS.DELAYED
      );
    },
    getVisitorObligations(visitor) {
      return this.obligations.filter(o => o.referenceId == visitor._id);
    },
    isDelayed(id) {
      return this.delayedObligations && this.delayedObligations.length > 0
        ? this.delayedObligations.filter(o => o.referenceId == id).length > 0
        : false;
    },
    getVisitorStates(visitorState) {
      let filteredVisitorStates = [];
      this.visitorStates.forEach(state => {
        if ((visitorState == 'entered' && state["value"] == 'entered')
            || state["value"] == 'left'
            || (visitorState != 'entered' && state["value"] == 'reentered')) { 
          filteredVisitorStates.push(state);
        }
      });
      return filteredVisitorStates;
    },
    async updateVisitorState(visitor) {
      await contractorCompanyService.updateVisitorState(
        this.visit._id,
        visitor._id,
        visitor.state
      );
    }
  },
  props: {
    obligations: { type: Array },
    delayedObligations: { type: Array },
    visit: { type: Object }
  }
};
</script>

<style lang="scss">
#admin-contractor-profile #employees .container {
  padding: 0 0 0 5px;
    .v-list.v-sheet.theme--light.v-list--two-line {
      padding-left: 0px;
  }
}

#admin-contractor-profile #vehicles .container {
  padding: 0 0 0 5px;
  
}

#viewVisitDetail {
  .v-navigation-drawer__content {
      padding: 0;
    .container {
      .row {
        .v-list-item {
          padding: 0 0 0 12px;
        }
        .col {
          padding: 0px;
        }
      }
    }
    .col {
        padding: 0px;
    }
    .v-list-item__title.capitalize {
        padding-left: 12px;
    }
  }
  .visitors-line {
    margin: 12px 28px;
  }
  .v-toolbar__content {
        padding-left: 24px;
    }
  .v-toolbar__title {
      padding: 0px;
  }
}
</style>
